<div class="supplier-transaction-page">
    <div class="page-header">
        <h1>Transactions</h1>
    </div>

    <div class="tables-container">
        <!-- Transaction Request Table -->
        <div class="table-section">
            <div class="table-header">
                <h2>Requests</h2>
            </div>

            <app-supplier-transaction-requests-table></app-supplier-transaction-requests-table> 
        </div>

        <!-- Authorization Table -->
        <div class="table-section">
            <div class="table-header">
                <h2>Authorizations</h2>
            </div>

            <app-supplier-authorizations-table></app-supplier-authorizations-table>
        </div>
    </div>
</div>